import React from 'react';
const steps = [{
  num: '1',
  title: 'DESCARGA',
  desc: 'Recibe acceso inmediato a las +10,000 plantillas del kit directamente en tu email.',
  icon: '📥',
  color: 'bg-pink-500',
  border: 'border-pink-500'
}, {
  num: '2',
  title: 'PERSONALIZA',
  desc: 'Abre en Canva gratis desde tu teléfono o computadora. Cambia nombres, colores, personajes y textos en minutos. Sin experiencia necesaria.',
  icon: '🎨',
  color: 'bg-orange-400',
  border: 'border-orange-400'
}, {
  num: '3',
  title: 'IMPRIME Y DECORA',
  desc: 'Imprime en casa o en cualquier imprenta local. Corta, monta y sorprende a tu hijo y a todos los invitados con una fiesta digna de Pinterest. 🎉',
  icon: '✂️',
  color: 'bg-teal-400',
  border: 'border-teal-400'
}];
export function ThreeSteps() {
  return <section className="py-20 px-4 relative bg-white" data-id="element-480">
      <div className="max-w-5xl mx-auto" data-id="element-481">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-orange-500 mb-16" data-id="element-482">
          3 PASOS PARA UNA FIESTA INCREÍBLE
        </h2>

        <div className="flex flex-col md:flex-row gap-8 relative" data-id="element-483">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-10 right-10 h-2 bg-pink-100 rounded-full z-0" data-id="element-484"></div>

          {steps.map((step, index) => <div key={index} className="flex-1 relative z-10" data-id="element-485">
              <div className={`bg-white rounded-3xl p-8 shadow-xl border-b-8 ${step.border} h-full flex flex-col items-center text-center transform hover:-translate-y-2 transition-transform duration-300`} data-id="element-486">
                <div className={`w-20 h-20 ${step.color} text-white rounded-full flex items-center justify-center text-3xl font-bold font-baloo shadow-lg mb-6 border-4 border-white -mt-14`} data-id="element-487">
                  {step.num}
                </div>
                <div className="text-4xl mb-4" data-id="element-488">{step.icon}</div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 font-baloo" data-id="element-489">
                  PASO {step.num} — {step.title}
                </h3>
                <p className="text-gray-600 font-medium leading-relaxed" data-id="element-490">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}